import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { ClientBaseUrl, ServerBaseUrl } from '../../model/constants';


const PromotionsIndex = () => {
    const jsonUrl = `${ServerBaseUrl}/promotions/`;
    const [filteredPromotions, setFilteredPromotions] = useState([]);
    const [promotions, setPromotions] = useState([]);

    const initializePromotions = (data) => {
        setPromotions(data.promotions);
        setFilteredPromotions(data.promotions);
    };

    const openBizionarUrl = (promotion) => {
        const bizionarUrl = `${ClientBaseUrl}/${promotion.projectId}`;
        window.open(bizionarUrl, '_blank', 'noreferrer');
    };

    const openLookurl = (promotion) => {
        const lookUrl = `https://look.metrovacesa.com/developments/${promotion.lookId}`;
        window.open(lookUrl, '_blank', 'noreferrer');
    };

    const formChanged = (event) => {
        console.log(event.target.value);

        const newPromotions = [];
        promotions.forEach((promotion) => {
           if (promotion.projectName.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1) {
               newPromotions.push(promotion);
           }
        });
        setFilteredPromotions(newPromotions);
    };

    const { isLoading, error } = useQuery(
        ['promotions'],
        () => fetch(jsonUrl)
            .then(res => res.json()).then(data => initializePromotions(data)),
    );
    if (isLoading) return null;
    return (
      <>
        <div className="promotions-title">Listado de promociones</div>
        <div className="form-container">
          <form className="form" onChange={formChanged}>
            <input
              className="input"
              name="code"
              type="text"
              id="input-code"
              placeholder=""
              defaultValue=""
            />
          </form>
        </div>
        <div className="promotions-container">
          {filteredPromotions.map((promotion, index) => (
            <div className="promotion-container">
              <div className="title">{promotion.projectName}</div>
              <button
                type="button"
                className="bizionar-link"
                onClick={() => openBizionarUrl(promotion)}
              >
                Enlace Bizionar
              </button>
              <button
                type="button"
                className="look-link"
                onClick={() => openLookurl(promotion)}
              >
                Enlace Look
              </button>
            </div>
                ))}

        </div>
      </>
    );
};

export default PromotionsIndex;
